/* Isolated header controller for the Homepage V2 multi-store replication. */
(function () {
  "use strict";

  function one(selector, root) { return (root || document).querySelector(selector); }
  function all(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  function containedKioskUrl(value) {
    try {
      var parsed = new URL(value, window.location.href);
      var host = parsed.hostname.toLowerCase();
      var path = parsed.pathname.replace(/\/+$/, "") || "/";
      var tab = (parsed.searchParams.get("tab") || "").toLowerCase();
      var trusted = host === "drsknn.uk" || host === "www.drsknn.uk";
      var treatments = path === "/kiosk/treatments" || (path === "/kiosk" && tab === "treatments");
      var consultations = path === "/kiosk/consultations" || (path === "/kiosk" && tab === "consultations");
      if (trusted && (treatments || consultations)) {
        parsed.protocol = "https:";
        parsed.hostname = "www.drsknn.uk";
        parsed.pathname = "/clinic-kiosk";
        parsed.searchParams.set("tab", treatments ? "treatments" : "consultations");
        return parsed.toString();
      }
    } catch (_) {}
    return value;
  }

  window.drsknnContainedKioskUrl = window.drsknnContainedKioskUrl || containedKioskUrl;

  function closeDropdowns(root) {
    all("[data-rp-dropdown]", root).forEach(function (dropdown) {
      dropdown.classList.remove("is-active");
      var toggle = one("[data-rp-dropdown-toggle]", dropdown);
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    });
  }

  function setPageLocked(locked) {
    document.documentElement.classList.toggle("drsknn-rp-layer-open", locked);
    document.body.classList.toggle("drsknn-rp-layer-open", locked);
  }

  function init(root) {
    if (!root || root.dataset.drsknnRpHeaderReady === "true") return;
    root.dataset.drsknnRpHeaderReady = "true";
    var search = one("[data-rp-search]", root);
    var searchOpen = one("[data-rp-search-open]", root);
    var searchInput = one("[data-rp-search-input]", root);
    var kiosk = one("[data-rp-kiosk]", root);
    var kioskDialog = one(".drsknn-rp-kiosk__dialog", kiosk);
    var kioskFrame = one("[data-rp-kiosk-frame]", kiosk);
    var lastFocus = null;

    function closeSearch(restore) {
      if (!search || search.hidden) return;
      search.hidden = true;
      search.setAttribute("aria-hidden", "true");
      if (searchOpen) searchOpen.setAttribute("aria-expanded", "false");
      setPageLocked(Boolean(kiosk && !kiosk.hidden));
      if (restore !== false && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function openSearch() {
      if (!search) return;
      closeDropdowns(root);
      lastFocus = document.activeElement;
      search.hidden = false;
      search.setAttribute("aria-hidden", "false");
      if (searchOpen) searchOpen.setAttribute("aria-expanded", "true");
      setPageLocked(true);
      window.requestAnimationFrame(function () { if (searchInput) searchInput.focus({ preventScroll: true }); });
    }

    function closeKiosk(restore) {
      if (!kiosk || kiosk.hidden) return;
      kiosk.hidden = true;
      kiosk.setAttribute("aria-hidden", "true");
      if (kioskFrame) kioskFrame.removeAttribute("src");
      setPageLocked(Boolean(search && !search.hidden));
      if (restore !== false && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function openKiosk(url) {
      if (!kiosk || !kioskFrame) {
        window.location.assign(url);
        return;
      }
      closeDropdowns(root);
      closeSearch(false);
      lastFocus = document.activeElement;
      kioskFrame.src = containedKioskUrl(url);
      kiosk.hidden = false;
      kiosk.setAttribute("aria-hidden", "false");
      setPageLocked(true);
      window.requestAnimationFrame(function () { if (kioskDialog) kioskDialog.focus({ preventScroll: true }); });
    }

    window.openPabauModal = openKiosk;
    window.closeModal = closeKiosk;

    root.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-rp-dropdown-toggle]");
      if (toggle && root.contains(toggle)) {
        event.preventDefault();
        var dropdown = toggle.closest("[data-rp-dropdown]");
        var opening = dropdown && !dropdown.classList.contains("is-active");
        closeDropdowns(root);
        if (dropdown) dropdown.classList.toggle("is-active", Boolean(opening));
        toggle.setAttribute("aria-expanded", opening ? "true" : "false");
        return;
      }
      var treatment = event.target.closest("[data-rp-treatment-booking]");
      if (treatment && root.contains(treatment)) {
        if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        openTreatmentFinder(treatment.getAttribute("href"), treatment);
        return;
      }
      if (event.target.closest("[data-rp-search-open]")) { event.preventDefault(); openSearch(); return; }
      if (event.target.closest("[data-rp-search-close]")) { event.preventDefault(); closeSearch(true); return; }
      if (event.target.closest("[data-rp-kiosk-close]")) { event.preventDefault(); closeKiosk(true); return; }
      if (!event.target.closest("[data-rp-dropdown]")) closeDropdowns(root);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (kiosk && !kiosk.hidden) { event.preventDefault(); closeKiosk(true); }
      else if (search && !search.hidden) { event.preventDefault(); closeSearch(true); }
      else closeDropdowns(root);
    });
  }

  function closeMenuLayers() {
    all("[data-drsknn-menu-v2][open]").forEach(function (details) { details.removeAttribute("open"); });
    document.documentElement.classList.remove("drsknn-menu-v2-open");
    document.body.classList.remove("drsknn-menu-v2-open", "overflow-hidden-tablet");
  }

  window.openDrSknnConsultation = function () {
    closeMenuLayers();
    if (typeof window.drsknnOpenConsultationChooser === "function") {
      window.drsknnOpenConsultationChooser();
      return;
    }
    var root = one("[data-drsknn-v5]");
    var trigger = root && one("[data-v5-open-consultation]", root);
    if (trigger) { trigger.click(); return; }
    window.location.assign("/?open=consultation");
  };

  function requestedConsultation() {
    if ((window.location.pathname || "").toLowerCase() !== "/") return false;
    try {
      var requested = new URLSearchParams(window.location.search || "").get("open") || "";
      return requested === "consultation" || requested === "booking";
    } catch (_) { return false; }
  }

  function handoffRequestedConsultation() {
    if (!requestedConsultation() || document.documentElement.dataset.drsknnRpConsultationWaiting === "true") return;
    document.documentElement.dataset.drsknnRpConsultationWaiting = "true";
    var attempts = 0;
    function attempt() {
      if (one('[data-v5-modal="consultation"].is-open')) return;
      if (typeof window.drsknnOpenConsultationChooser === "function") { window.drsknnOpenConsultationChooser(); return; }
      attempts += 1;
      if (attempts < 50) window.setTimeout(attempt, 120);
    }
    window.setTimeout(attempt, 80);
  }

  function closeNavigation() {
    closeDropdowns(document);
    closeMenuLayers();
    all("[data-rp-search]").forEach(function (search) {
      search.hidden = true;
      search.setAttribute("aria-hidden", "true");
    });
    all("[data-rp-search-open]").forEach(function (button) { button.setAttribute("aria-expanded", "false"); });
    setPageLocked(false);
  }

  // Book treatment has its own intent. Ordinary pricing links keep their route.
  var TREATMENT_FINDER_URL = "/?open=treatment";
  var treatmentRequest = null;
  var treatmentRequestId = 0;
  var treatmentHandoffScheduled = false;

  function bookingReturnTrigger(trigger) {
    if (!trigger || !trigger.closest) return trigger || null;
    var drawer = trigger.closest("[data-drsknn-menu-v2]");
    if (drawer) return drawer.querySelector("summary") || trigger;
    var dropdown = trigger.closest("[data-rp-dropdown]");
    return dropdown ? dropdown.querySelector("button[aria-expanded]") || trigger : trigger;
  }

  function restoreBookingTrigger(trigger) {
    if (trigger && trigger.isConnected && typeof trigger.focus === "function") trigger.focus({ preventScroll: true });
  }

  function bookingLoadNotice(message, retryHref, trigger) {
    var old = document.querySelector("[data-drsknn-booking-load-status]");
    if (old) old.remove();
    var notice = document.createElement("div");
    notice.setAttribute("data-drsknn-booking-load-status", "");
    notice.style.cssText = "position:fixed;z-index:2147483600;left:50%;bottom:max(18px,env(safe-area-inset-bottom));transform:translateX(-50%);width:min(460px,calc(100vw - 32px));padding:18px;background:#fff;color:#143137;border:1px solid #aaccc6;border-radius:16px;box-shadow:0 12px 44px #062e3433;font:600 15px/1.5 system-ui,sans-serif;display:flex;gap:12px;align-items:center;flex-wrap:wrap";
    var text = document.createElement("span");
    text.setAttribute("role", "status");
    text.setAttribute("aria-live", "polite");
    text.style.cssText = "flex:1 1 200px";
    text.textContent = message;
    notice.appendChild(text);
    if (retryHref) {
      var retry = document.createElement("a");
      retry.href = retryHref;
      retry.textContent = "Reload booking";
      retry.style.cssText = "color:#075b58;text-decoration:underline;font:inherit";
      notice.appendChild(retry);
    }
    var cancel = document.createElement("button");
    cancel.type = "button";
    cancel.textContent = retryHref ? "Dismiss" : "Cancel";
    cancel.style.cssText = "border:1px solid #aaccc6;border-radius:8px;padding:8px 12px;background:#f1f7f5;color:#143137;font:inherit;cursor:pointer";
    cancel.addEventListener("click", function () {
      treatmentRequestId += 1;
      if (treatmentRequest && treatmentRequest.trigger) treatmentRequest.trigger.removeAttribute("aria-busy");
      treatmentRequest = null;
      notice.remove();
      restoreBookingTrigger(trigger);
    });
    notice.appendChild(cancel);
    document.body.appendChild(notice);
    return notice;
  }

  function bookingApiReady() {
    return Boolean(window.DrSknnPricingV3 && typeof window.DrSknnPricingV3.openBookingFinder === "function");
  }

  function loadBookingCatalogue() {
    return new Promise(function (resolve) {
      var settled = false;
      var timeout = window.setTimeout(function () { finish(false); }, 12000);
      function finish(ready) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        resolve(Boolean(ready && bookingApiReady()));
      }
      function attempt() {
        if (settled) return;
        if (bookingApiReady()) { finish(true); return; }
        var loader = window.DrSknnHomepageV2Performance;
        if (loader && typeof loader.loadPricing === "function") {
          Promise.resolve().then(function () { return loader.loadPricing(); }).then(finish, function () { finish(false); });
          return;
        }
        // Standalone pricing pages load their controller with defer. The global
        // header can become ready first, so wait for that controller without scrolling.
        window.setTimeout(attempt, 80);
      }
      attempt();
    });
  }

  function openTreatmentFinder(destination, trigger) {
    var href = destination || TREATMENT_FINDER_URL;
    var target;
    try { target = new URL(href, window.location.href); } catch (_) { return Promise.resolve(false); }
    var returnTrigger = bookingReturnTrigger(trigger || document.activeElement);
    closeNavigation();
    var pricing = document.querySelector("[data-drsknn-pricing-v3]");
    var localRestricted = pricing && pricing.dataset.pricingV3Catalogue === "advertising";
    var targetRestricted = target.searchParams.get("view") === "drsknn-pricing-v3-adsafe";
    var localCompatible = pricing && target.origin === window.location.origin && Boolean(localRestricted) === targetRestricted;
    if (!localCompatible) {
      var current = new URL(window.location.href);
      if (target.pathname !== current.pathname || target.searchParams.get("view") !== current.searchParams.get("view") || target.origin !== current.origin) {
        window.location.assign(href);
      } else {
        bookingLoadNotice("Booking options could not load. Reload this page to try again.", href, returnTrigger);
      }
      return Promise.resolve(false);
    }
    if (treatmentRequest) return treatmentRequest.promise;
    var retryUrl = new URL(window.location.href);
    retryUrl.searchParams.set("open", "treatment");
    retryUrl.hash = "";
    var retryHref = retryUrl.toString();
    var requestId = ++treatmentRequestId;
    var notice = bookingLoadNotice("Opening treatment booking…", "", returnTrigger);
    if (returnTrigger) returnTrigger.setAttribute("aria-busy", "true");
    var request = { trigger: returnTrigger, promise: null };
    treatmentRequest = request;
    request.promise = loadBookingCatalogue().then(function (ready) {
      if (requestId !== treatmentRequestId) return false;
      if (returnTrigger) returnTrigger.removeAttribute("aria-busy");
      treatmentRequest = null;
      if (ready) {
        notice.remove();
        try {
          if (window.DrSknnPricingV3.openBookingFinder(returnTrigger) !== false) return true;
        } catch (_) {}
      }
      // The lazy loader caches failures. A deliberate reload is a real retry;
      // silently revisiting the pricing anchor would strand the patient again.
      bookingLoadNotice("Booking options could not load. Reload this page to try again.", retryHref, returnTrigger);
      return false;
    });
    return request.promise;
  }

  function scheduleRequestedTreatment() {
    if (treatmentHandoffScheduled) return;
    try {
      if (new URLSearchParams(window.location.search || "").get("open") !== "treatment") return;
    } catch (_) { return; }
    treatmentHandoffScheduled = true;
    openTreatmentFinder(window.location.href, null);
  }

  window.openDrSknnTreatmentFinder = openTreatmentFinder;
  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("a[data-drsknn-treatment-finder]");
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openTreatmentFinder(link.getAttribute("href"), link);
  });

  function boot() {
    all("[data-drsknn-rp-header]").forEach(init);
    handoffRequestedConsultation();
    scheduleRequestedTreatment();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
  window.addEventListener("pageshow", handoffRequestedConsultation);
  window.addEventListener("pageshow", scheduleRequestedTreatment);
})();
